import React from "react";
import PropTypes from "prop-types";

import "./buttonNav.css";

function buttonNav(props) {
  return (
    <div className={props.className} onClick={props.onClick}>
      <img src={props.src} alt={props.text} height={82}/>
      <p>{props.text}</p>
    </div>
  );
}

buttonNav.propTypes = {
  src: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClicK: PropTypes.func
};

export default buttonNav;
